module.exports = __webpack_public_path__ + "media/images/partners/microsoft-86d06014645794370441fa6447900bc9.svg";